export default __webpack_public_path__ + "img/88ec793ff3a8f9ee6bf593a6fd5bfbf7.svg";